import AcceptableDocsLink from 'common/components/links/AcceptableDocsLink';
import React, { useEffect, useState } from 'react';
import { Button, Col, Nav, Row, Tab } from 'react-bootstrap';
import { RouteComponentProps } from 'react-router';
import * as HowTos from './howTos';

const Help = ({ match }: RouteComponentProps<{ incomingKey?: string }>) => {
  const [key, setKey] = useState('creatingAccount');
  useEffect(() => {
    if (match.params.incomingKey) {
      setKey(match.params.incomingKey);
    }
  }, []);

  return (
    <>
      <h1>Help Tools and Resources</h1>
      <p>
        Below we have listed a number of articles that will help guide you
        through all aspects of this application process. We’ve included
        essential steps such as creating your account, applying for a short term
        rental license, and more.
      </p>
      <hr />
      <Tab.Container
        //defaultActiveKey='creatingAccount'
        activeKey={key}
        onSelect={(k) => (k != null ? setKey(k) : setKey('creatingAccount'))}
      >
        <Row>
          <Col sm={3}>
            <Nav variant='pills' className='flex-column'>
              <h3>How-to Guides</h3>
              <small className='d-md-none text-muted'>
                Tap an option and then scroll down to view the guide.
              </small>
              <Nav.Item>
                <Nav.Link eventKey='creatingAccount'>
                  Creating an Account
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey='uploadingIdentity'>
                  Uploading your Identity
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey='mailingAddress'>
                  Entering Mailing Information
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey='applyingForRegistration'>
                  Applying for a Registration Number
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey='payment'>
                  Payment for Your House Share Registration Fee
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey='reupload'>
                  Re-uploading Information
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey='forgotPassword'>
                  Forgot Your Password?
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey='renewYourRegistrationNumber'>
                  Renew Your Registration Number
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey='modifyingIntermediaryRoomSelections'>
                  Modifying Intermediary/Room Selections
                </Nav.Link>
              </Nav.Item>
              <h3 className='mt-4'>Additional Resources</h3>
              {/*<QuickReferenceGuideLink style={{ padding: '0.5rem 1rem' }} />*/}
              <a
                style={{ padding: '0.5rem 1rem' }}
                href={`https://codelibrary.amlegal.com/codes/chicago/latest/chicago_il/0-0-0-2611518`}
                target='_blank'
                rel='noreferrer'
              >
                Shared Housing Ordinance
              </a>
              <AcceptableDocsLink style={{ padding: '0.5rem 1rem' }} />
              <a
                style={{ padding: '0.5rem 1rem' }}
                href={`https://data.cityofchicago.org/Buildings/House-Share-Prohibited-Buildings-List/7bzs-jsyj/data`}
                target='_blank'
                rel='noreferrer'
              >
                Prohibited Building List
              </a>
              <a
                style={{ padding: '0.5rem 1rem' }}
                href={`https://www.chicityclerk.com/houseshare/restricted-precincts`}
                target='_blank'
                rel='noreferrer'
              >
                Restricted Residential Zones
              </a>
            </Nav>
          </Col>
          <Col className='py-4' sm={9} style={{ backgroundColor: '#F9F9F9' }}>
            <Tab.Content>
              <Tab.Pane eventKey='creatingAccount'>
                <HowTos.CreateAnAccount />
              </Tab.Pane>
              <Tab.Pane eventKey='uploadingIdentity'>
                <HowTos.UploadingYourIdentity />
              </Tab.Pane>
              <Tab.Pane eventKey='mailingAddress'>
                <HowTos.EnteringMailingInformation />
              </Tab.Pane>
              <Tab.Pane eventKey='applyingForRegistration'>
                <HowTos.ApplyingForRegistrationNumber />
              </Tab.Pane>
              <Tab.Pane eventKey='payment'>
                <HowTos.PaymentForRegistration />
              </Tab.Pane>
              <Tab.Pane eventKey='reupload'>
                <HowTos.ReuploadingInformation />
              </Tab.Pane>
              <Tab.Pane eventKey='forgotPassword'>
                <HowTos.ForgotPassword />
              </Tab.Pane>
              <Tab.Pane eventKey='renewYourRegistrationNumber'>
                <HowTos.RenewYourRegistrationNumber />
              </Tab.Pane>
              <Tab.Pane eventKey='modifyingIntermediaryRoomSelections'>
                <HowTos.ModifyingIntermediaryRoomSelections />
              </Tab.Pane>
            </Tab.Content>
            <Row>
              <Col className='text-center d-print-none'>
                <Button
                  variant='link'
                  onClick={() => {
                    window.scrollTo(0, 0);
                  }}
                >
                  Back to Top
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Tab.Container>
    </>
  );
};

export default Help;
